import type { MilestoneMessage } from '../types';

/**
 * A message thread with the latest message first (ClickUp 869fgj86n): in a
 * long objection or conflict thread the current message is at the top. Equal
 * timestamps keep their reversed arrival order.
 */
export const newestFirst = <T extends Pick<MilestoneMessage, 'createdAt'>>(messages: T[]): T[] =>
  [...messages]
    .reverse()
    .sort((left, right) => (Date.parse(right.createdAt) || 0) - (Date.parse(left.createdAt) || 0));
